import { omit } from 'lodash';
import { StoreCategoryModel } from './StoreCategoryModel';
export class StoreBasicModel {
    constructor(payload) {
        const basicPayload = omit(payload, 'storeCategory');
        Object.assign(this, basicPayload);
        const { storeCategory } = payload;
        if (storeCategory) {
            this.storeCategory = new StoreCategoryModel(storeCategory);
        }
    }
    get emailRecipients() {
        const recipients = this.emailNotifRecipients || '';
        return recipients.split(',');
    }
}
